import {
    FETCHED_SITES_LANGUAGES,
    CHANGE_SITE_LANGUAGE,
    UPDATED_SITES_LANGUAGES,
} from './types';

export function fetchedSitesLanguages(langsSites) {
    return {
        type: FETCHED_SITES_LANGUAGES,
        payload: {
            data: langsSites
        }
    }
}

export function changeSiteLanguage(siteId, languageId, checked) {
    return {
        type: CHANGE_SITE_LANGUAGE,
        payload: {
            siteId: siteId,
            languageId: languageId,
            checked: checked,
            touched: true
        }
    }
}

export function updatedSitesLanguages(response) {
    return {
        type: UPDATED_SITES_LANGUAGES,
        payload: response,
        touched: false
    }
}


// WEBPACK FOOTER //
// ./src/containers/configuration/actions.js